import { render } from "./MedidasComponent.vue?vue&type=template&id=4cf0c5c8&scoped=true"
import script from "./MedidasComponent.vue?vue&type=script&lang=js"
export * from "./MedidasComponent.vue?vue&type=script&lang=js"

import "./MedidasComponent.vue?vue&type=style&index=0&id=4cf0c5c8&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf0c5c8"]])

export default __exports__